import React from 'react';
import { SvgIcon } from '@mui/material';

function FolderIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.33329 3.33325H3.33329C2.41663 3.33325 1.67496 4.08325 1.67496 4.99992L1.66663 14.9999C1.66663 15.9166 2.41663 16.6666 3.33329 16.6666H16.6666C17.5833 16.6666 18.3333 15.9166 18.3333 14.9999V6.66659C18.3333 5.74992 17.5833 4.99992 16.6666 4.99992H9.99996L8.33329 3.33325Z"
          fill="#656985"
        />
      </svg>
    </SvgIcon>
  );
}

export default FolderIcon;
